import React from "react";
import MyAttendanceListData from "../AttendanceListData/MyAttendanceListData";
import moment from "moment";
import { useGetListOfClockInAndClockOut } from "../../../queries/attendanceQuries";
import EmptyState from "../../EmptyState";
import PageLoader from "../../PageLoader/PageLoader";

const MyAttendanceTable = ({ selectedOption, label, fromDate, toDate }) => {
  const fromDateFormatted = moment(fromDate).format("YYYY-MM-DD");
  const toDateFormatted = moment(toDate).format("YYYY-MM-DD");

  const { data, isLoading } = useGetListOfClockInAndClockOut({
    from_date: fromDateFormatted,
    to_date: toDateFormatted,
    ...(label?.value ? { label: label.value } : {}),
    ...(selectedOption?.value ? { selectedOption: selectedOption.value } : {}),
  });

  const clockInClockOutList = data?.data?.data || [];

  return (
    <div className="relative overflow-x-auto">
      {isLoading ? (
        <PageLoader />
      ) : Array.isArray(clockInClockOutList) &&
        clockInClockOutList.length > 0 ? (
        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-500">
          <thead className="text-xs font-medium uppercase bg-gray-50 dark:bg-gray-50 text-gray-800 border-b border-t dark:border-gray-200 tracking-wider">
            <tr>
              <th className="px-10 py-3">Attendance Date</th>
              <th className="px-10 py-3">First Clock-In</th>
              <th className="px-10 py-3">Last Clock-Out</th>
              <th className="px-10 py-3">Overtime/Deviation</th>
              <th className="px-10 py-3">Total Hours</th>
              <th className="px-10 py-3">Attendance Status</th>
            </tr>
          </thead>
          <tbody>
            <MyAttendanceListData
              fromDate={fromDate}
              toDate={toDate}
              attendanceData={clockInClockOutList}
              isProcessAttendance={false}
            />
          </tbody>
        </table>
      ) : (
        <EmptyState />
      )}
    </div>
  );
};

export default MyAttendanceTable;
